import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userActions } from '../../_actions';
import LoadingOverlay from 'react-loading-overlay';
import ReactPaginate from 'react-paginate';
import DialogExample from "./components/DialogExample/DialogExample";
import AddLeadModal from "./components/AddLeadModal";
import AddFollowUpModal from "./components/AddFollowUpModal/AddFollowUpModal";
import ShowFollowUpModal from "./components/ShowFollowUpModal";
import UpdateLeadModal from "./components/UpdateLeadModal";
import { isMobile } from "react-device-detect";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { BiSearch } from "react-icons/bi";
import { MdAdd } from "react-icons/md";
import { BiDetail } from "react-icons/bi";
import moment from "moment";
import { MdOutlineEdit } from "react-icons/md";
import { GrAddCircle } from "react-icons/gr";
import './style.css'
import { BiArrowBack } from "react-icons/bi";
import dayjs from 'dayjs';


class ActiveReminder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVideo: false,
      isVideoUpdate: false,
      showFollowUpModal: false,
      selectedUser: [],
      updateSelectedUser: [],
      selectedCategory: [],
      updateSelectedCategory: [],
      selectedValue: "",
      dateAndTimeValue: "",
      userRowData: {},
      fieldsQuote: {},
      errorsQuote: {},
      fieldsFollowUp: {
        // dateAndTimeValue: moment(new Date()).format("YYYY-MM-DD HH:mm")
        dateAndTimeValue: dayjs().hour(10).minute(0)
      },
      errorsFollowUp: {},
      fieldsUserUpdate: {},
      fieldsUserPasswordUpdate: {},
      errorsUpdateQuote: {},
      errorsUpdatePassword: {},
      viewRowData: {},
      type: null,
      gameType: null,
      rankType: null,
      addQuoteModal: false,
      moreDetailsCreateModal: false,
      UpdateQuoteCreateModal: false,
      loginToThisAccountModal: false,
      addLeadModal: false,
      creditpasswordOpenModal: false,
      followUpModal: false,
      fieldsUser: {},
      errorsUpdate: {},
      AddBalanceModal: false,
      show: true,
      balance: '',
      offset: 0,
      size: 10,
      pageNo: 1,
      keyWord: '',
      userIdCustom: null,
      updatePwdformData: {
        "id": "",
        "password": ""
      }
    }
  }
  componentDidMount() {

    let userIdCustom = JSON.parse(localStorage.getItem('userIdCustom'));

    this.setState({ userIdCustom: userIdCustom })

    let reqData = {
      "userIdCustom": userIdCustom ? userIdCustom : null,
      "isFollowup": false,
      "keyWord": this.state.keyWord,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(userActions.getReminderList(reqData));
    // this.props.dispatch(userActions.getLeadList(reqData));
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.users.addUserSuccess) {
      return {
        ...nextProps,
        selectedCategory: {},
        fieldsUserUpdate: {},
        fieldsUserPasswordUpdate: {},
        errorsUpdateQuote: {},
        fieldsQuote: {},
        errorsQuote: {},
        errorsUpdatePassword: {},
        UpdateQuoteCreateModal: false,
        creditpasswordOpenModal: false,
        addLeadModal: false,
        addQuoteModal: false,
        followUpModal: false,
        fieldsUser: {},
        errorsUpdateQuoteAdd: {},
        errorsUpdate: {},
        AddBalanceModal: false,
        DeductBalanceModal: false,
        balance: '',
        idParam: '',
        fieldsUserdeduct: ''

      }
    } else {
      return {
        ...nextProps,

      }
    }
  }


  onSelect = (selectedList, selectedItem) => {
    this.setState({ selectedCategory: selectedList });
  }

  onRemove = (selectedList, removedItem) => {
    console.log('selectedList', selectedList);
    console.log('removedItem', removedItem);
    this.setState({ selectedCategory: selectedList });
  }

  onSelectUpdate = (selectedList, selectedItem) => {
    this.setState({ updateSelectedCategory: selectedList });
  }

  onRemoveUpdate = (selectedList, removedItem) => {
    console.log('selectedList', selectedList);
    console.log('removedItem', removedItem);
    this.setState({ updateSelectedCategory: selectedList });
  }
  // //////////////////////////////////////////////////


  onUserSelect = (selectedList, selectedItem) => {
    this.setState({ selectedUser: selectedList });
  }

  onUserRemove = (selectedList, removedItem) => {
    console.log('selectedList', selectedList);
    console.log('removedItem', removedItem);
    this.setState({ selectedUser: selectedList });
  }

  onUserSelectUpdate = (selectedList, selectedItem) => {
    this.setState({ updateSelectedUser: selectedList });
  }

  onUserRemoveUpdate = (selectedList, removedItem) => {
    console.log('selectedList', selectedList);
    console.log('removedItem', removedItem);
    this.setState({ updateSelectedUser: selectedList });
  }



  handlePageClick = (data) => {
    console.log("data  ", data);
    let offset = Math.ceil(data.selected * this.state.size);
    this.setState({ offset: offset, page: data.selected });
    let datatemp = {
      "userIdCustom": this.state.userIdCustom,
      "isFollowup": false,
      "keyWord": this.state.keyWord,
      "pageNo": data.selected + 1,
      "size": this.state.size
    }
    this.props.dispatch(userActions.getReminderList(datatemp));
  }

  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "userIdCustom": this.state.userIdCustom,
      "isFollowup": false,
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(userActions.getReminderList(data));
  }

  disableReminder = (data) => {
    let datatemp = {
      "id": data.id,
    }
    let paginationdata = {
      "userIdCustom": this.state.userIdCustom,
      "isFollowup": false,
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size
    }
    confirmAlert({
      title: 'Confirm to change status Reminder?',
      message: `Are you sure to change status of ${data.name} reminder?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.dispatch(userActions.disableReminder(datatemp, paginationdata))
        },
        {
          label: 'No'
        }
      ]
    });
  }

  deleteLead = (data) => {
    let datatemp = {
      "id": data.id,
    }
    let paginationData = {
      "userIdCustom": this.state.userIdCustom,
      "isFollowup": false,
      "keyWord": this.state.keyWord,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }

    confirmAlert({

      title: 'Confirm to Delete?',
      message: `Are you sure to delete ${data.name} lead?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.dispatch(userActions.deleteLead(datatemp, paginationData))
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleOpenCreateModalMoreDetails = (data) => {
    this.props.history.push("/app/moreDetails/" + data.leadId.id)
  }

  handleMoreDetailsHideModal = () => {
    this.setState({ moreDetailsCreateModal: false });
  }

  handleShowFollowUpModal = (data) => {
    let reqData = {
      "leadId": data.leadId.id,
      "keyWord": this.state.keyWord,
      "pageNo": this.state.pageNo,
      "size": this.state.size

    }
    this.props.dispatch(userActions.getFollowUpListByLeadId(reqData))
    this.setState({ showFollowUpModal: true });
  }

  handleHideFollowUpModal = () => {
    this.setState({ showFollowUpModal: false });
  }

  handleOpenCreateModalUpdatePassword = (data) => {
    console.log('data........', data);
    this.props.dispatch(userActions.getAllCategory());
    this.props.dispatch(userActions.getAllUser());

    this.setState({ UpdateQuoteCreateModal: true, fieldsUserUpdate: data.leadId, updateSelectedCategory: data.leadId.categoryList, updateSelectedUser: data.leadId.assigneeList });
  }
  handleUpdatePasswordHideModal = () => {
    this.setState({ UpdateQuoteCreateModal: false, updateSelectedCategory: [], updateSelectedUser: [] });
  }

  handleAddUserHideModal = () => {
    this.setState({ addQuoteModal: false });
    // this.setState({ appsettingUpdateModal: false });
  }

  handleOpenCreateModal = () => {
    // console.log("clicked");
    this.setState({ addQuoteModal: true });
  }
  inputAddUserChange = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsQuote = this.state.fieldsQuote;
    let errorsQuote = this.state.errorsQuote;
    fieldsQuote[name] = value;
    console.log(name, value);
    errorsQuote[name] = "";
    this.setState({ fieldsQuote, errorsQuote });
  }

  inputChangeUpdateUser = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsUserUpdate = this.state.fieldsUserUpdate;
    let errorsUpdateQuote = this.state.errorsUpdateQuote;
    fieldsUserUpdate[name] = value;
    errorsUpdateQuote[name] = "";
    console.log(name, value);
    this.setState({ fieldsUserUpdate, errorsUpdateQuote });
  }

  inputChangeFollowUp = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsFollowUp = this.state.fieldsFollowUp;
    let errorsFollowUp = this.state.errorsFollowUp;
    fieldsFollowUp[name] = value;
    errorsFollowUp[name] = "";
    console.log(name, value);
    this.setState({ fieldsFollowUp, errorsFollowUp });
  }

  inputChangeUpdatePasswordUser = (e) => {
    e.preventDefault();
    console.log("1111111111111", e.target.value);
    let { name, value } = e.target;
    let fieldsUserPasswordUpdate = this.state.fieldsUserPasswordUpdate;
    let errorsUpdatePassword = this.state.errorsUpdatePassword;
    fieldsUserPasswordUpdate[name] = value;
    errorsUpdatePassword[name] = "";
    console.log(name, value);
    this.setState({ fieldsUserPasswordUpdate, errorsUpdatePassword });
  }

  createLeadSubmit = () => {
    if (this.handleValidationAddUser()) {
      let selectedCategoryData = this.state.selectedCategory && this.state.selectedCategory.length > 0 ?
        this.state.selectedCategory.map((element) => (element.id)) : null

      let selectedUserData = this.state.selectedUser && this.state.selectedUser.length > 0 ?
        this.state.selectedUser.map((element) => (element._id)) : null

      let reqData = {
        "name": this.state.fieldsQuote.name,
        "calenderDate": this.state.fieldsQuote.calenderDate,
        "categoryList": selectedCategoryData,
        "userList": selectedUserData,
        "requirement": this.state.fieldsQuote.requirement,
        "source": this.state.fieldsQuote.source,
      }
      this.props.dispatch(userActions.createLead(reqData));
    }
  }

  handleValidationAddUser = () => {
    let fieldsQuote = this.state.fieldsQuote;
    let errorsQuote = {};
    let formIsValid = true;

    //name
    if (!fieldsQuote["name"] || fieldsQuote["name"] === "") {
      formIsValid = false;
      errorsQuote["name"] = "Name cannot be empty";
    }
    //Date
    if (!fieldsQuote["calenderDate"] || fieldsQuote["calenderDate"] === "") {
      formIsValid = false;
      errorsQuote["calenderDate"] = "Date cannot be empty";
    }

    //requirement
    if (!fieldsQuote["requirement"] || fieldsQuote["requirement"] === "") {
      formIsValid = false;
      errorsQuote["requirement"] = "Requirement cannot be empty";
    }
    //source
    if (!fieldsQuote["source"] || fieldsQuote["source"] === "") {
      formIsValid = false;
      errorsQuote["source"] = "Source cannot be empty";
    }

    console.log('errorsUpdateQuoteerrorsUpdateQuoteerrorsUpdateQuote', errorsQuote);
    this.setState({ errorsQuote: errorsQuote });
    return formIsValid;
  }

  updateLead = () => {
    // let { users } = this.props;
    // let { filesDetails } = users;

    if (this.handleValidationUpdateUser()) {

      let selectedCategoryData = this.state.updateSelectedCategory && this.state.updateSelectedCategory.length > 0 ?
        this.state.updateSelectedCategory.map((element) => (element.id)) : null

      let selectedUserData = this.state.updateSelectedUser && this.state.updateSelectedUser.length > 0 ?
        this.state.updateSelectedUser.map((element) => (element._id)) : null

      let reqData = {
        "id": this.state.fieldsUserUpdate.id,
        "name": this.state.fieldsUserUpdate.name,
        "categoryList": selectedCategoryData,
        "userList": selectedUserData,
        "calenderDate": this.state.fieldsUserUpdate.calenderDate,
        "requirement": this.state.fieldsUserUpdate.requirement,
        "source": this.state.fieldsUserUpdate.source,
      }
      let paginationData = {
        "userIdCustom": this.state.userIdCustom,
        "keyWord": this.state.keyWord,
        "pageNo": this.state.pageNo,
        "size": this.state.size
      }
      this.props.dispatch(userActions.updateLead(reqData, paginationData));
    }
  }

  createFollowUp = () => {

    if (this.handleValidationComment()) {
      let reqData = {
        "leadId": this.state.fieldsUserUpdate.leadId.id,
        "comment": this.state.fieldsFollowUp.comment,
        "reminderDate": this.state.fieldsFollowUp.dateAndTimeValue,
        // "isFollowup": true
      }

      let remiderData = {
        "userIdCustom": this.state.userIdCustom,
        "isFollowup": false,
        "keyWord": this.state.keyWord,
        "pageNo": this.state.pageNo,
        "size": this.state.size
      }
      this.props.dispatch(userActions.createFollowUpReminder(reqData, remiderData));
    }
  }

  handleValidationUpdateUser = () => {
    let fieldsUserUpdate = this.state.fieldsUserUpdate;
    let errorsUpdateQuote = {};
    let formIsValid = true;

    //name
    if (!fieldsUserUpdate["name"] || fieldsUserUpdate["name"] === "") {
      formIsValid = false;
      errorsUpdateQuote["name"] = "Name cannot be empty";
    }

    //calenderDate
    if (!fieldsUserUpdate["calenderDate"] || fieldsUserUpdate["calenderDate"] === "") {
      formIsValid = false;
      errorsUpdateQuote["calenderDate"] = "Date cannot be empty";
    }
    //requirement
    if (!fieldsUserUpdate["requirement"] || fieldsUserUpdate["requirement"] === "") {
      formIsValid = false;
      errorsUpdateQuote["requirement"] = "Requirement cannot be empty";
    }
    //source
    if (!fieldsUserUpdate["source"] || fieldsUserUpdate["source"] === "") {
      formIsValid = false;
      errorsUpdateQuote["source"] = "Source cannot be empty";
    }
    console.log("errorsUpdateQuoteerrorsUpdateQuoteerrorsUpdateQuote", errorsUpdateQuote);
    this.setState({ errorsUpdateQuote: errorsUpdateQuote });
    return formIsValid;
  }

  handleValidationComment = () => {
    let fieldsUserUpdate = this.state.fieldsUserUpdate;
    let errorsUpdateQuote = {};
    let formIsValid = true;

    //comment
    if (!fieldsUserUpdate["comment"] || fieldsUserUpdate["comment"] === "") {
      formIsValid = false;
      errorsUpdateQuote["comment"] = "Comment cannot be empty";
    }

    console.log("errorsUpdateQuoteerrorsUpdateQuoteerrorsUpdateQuote", errorsUpdateQuote);
    this.setState({ errorsUpdateQuote: errorsUpdateQuote });
    return formIsValid;
  }

  handleAddLeadModal = () => {
    this.props.dispatch(userActions.getAllCategory());
    this.props.dispatch(userActions.getAllUser());

    this.setState({ addLeadModal: true, })
  }

  handleFollowUpOpenModal = (data) => {
    this.setState({
      followUpModal: true,
      show: true,
      fieldsFollowUp: { dateAndTimeValue: dayjs().hour(10).minute(0) },
      fieldsUserUpdate: data
    })
  }

  handlePasswordModal = (data) => {
    this.setState({ creditpasswordOpenModal: true, fieldsUserPasswordUpdate: data })
  }
  handleCreditpasswordHideModal = () => {
    this.setState({ creditpasswordOpenModal: false })
  }

  handleFollowUpHideModal = () => {
    this.setState({
      followUpModal: false,
      fieldsFollowUp: {
        dateAndTimeValue: dayjs().hour(10).minute(0)
      },
    })
  }

  handleDateChange = (newValue) => {
    let fieldsFollowUp = this.state.fieldsFollowUp;
    fieldsFollowUp["dateAndTimeValue"] = newValue

    this.setState({ fieldsFollowUp });
  };

  handleCreditActivityHideModal = () => {
    this.setState({ addLeadModal: false, selectedCategory: [], selectedUser: [] })
  }

  handleUpdatePasswordHideModalAdd = () => {
    this.setState({ AddBalanceModal: false });
  }
  handleUpdateHideModal = () => {
    this.setState({ DeductBalanceModal: false });
  }
  handleOpenCreateModalUpdatePasswordAddBal = (data) => {
    this.setState({ idParam: data && data.id });
    this.setState({ AddBalanceModal: true, fieldsUserUpdate: { id: this.props.match.params.id } });


    console.log("11111111111", data && data.id);
  }
  handleOpenCreateModalPassword = (data) => {
    this.setState({ DeductBalanceModal: true, fieldsUserdeduct: data.id });
  }

  handleValidationUpdateUserAdd = () => {
    let balance = this.state.balance;
    let errorsUpdateQuoteAdd = {};
    let formIsValid = true;

    //name
    if (!balance || balance === "") {
      formIsValid = false;
      errorsUpdateQuoteAdd["balance"] = "Cannot be empty";
    }

    this.setState({ errorsUpdateQuoteAdd: errorsUpdateQuoteAdd });
    return formIsValid;
  }

  setBalance = (e) => {
    e.preventDefault();
    let value = e.target.value;
    console.log('value__________', value);
    this.setState({ balance: value })
  }

  handleSelectedTag = (selectedTag) => {
    console.log("selectedselectedselected  ", selectedTag);
    this.setState({ selectedTag: selectedTag });
  };


  handleGoBack = () => {
    this.props.history.goBack();
  };

  handleCalender = () => {
    this.setState({ show: false, fieldsFollowUp: { ...this.state.fieldsFollowUp, dateAndTimeValue: "" } });
  };

  render() {

    let { users } = this.props;
    let { filesDetails, reminderItems, reminderTotal, loading, getAllCategory, getAllUser, followUpItems, followUpTotal } = users;

    return (

      <>
        <div>
          <LoadingOverlay
            active={loading}
            className="temp001"
            spinner
            text='Please wait...' />
        </div>

        <div className="flex flex-col flex-1 overflow-hidden overflow-y-auto">
          <main className="relative flex-1 ">
            <div className="p-3 2xl:p-10 sm:p-5">
              <div className="mx-auto max-w-screen-3xl ">
                {/* Transaction Section */}
                <section className="p-6 space-y-6 bg-white border rounded-md">

                  <div className="flex flex-wrap items-center justify-between w-full ">
                    <div className="flex space-x-6">
                      <div onClick={this.handleGoBack} className='p-1 text-gray-600 border border-gray-400 rounded-full cursor-pointer hover:bg-blue-400 hover:border-blue-400 hover:text-white'><BiArrowBack className='w-6 h-6' /></div>
                      <h3 className="font-medium text-xl text-[#3D405B] whitespace-nowrap">Active Reminder List</h3>
                    </div>

                    <div className='flex space-x-6 '>
                      <form action="#" method="GET"  >
                        <label htmlFor="mobile-search" className="sr-only">Search</label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <BiSearch style={{ fontSize: '1.5rem' }} className="text-gray-500" />
                          </div>
                          <input type="text" name="email" id="mobile-search" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  focus:ring-cyan-600 block w-full pl-10 p-2.5" placeholder="Search" onChange={this.handleSearch} required />
                        </div>
                      </form>
                      {/* <button className="flex items-center px-6 py-2 text-sm font-medium text-white capitalize bg-blue-500 rounded-md" onClick={() => this.handleAddLeadModal()}><MdAdd style={{ fontSize: "1.5rem" }} className="mr-1.5" /> Add Lead </button> */}
                    </div>
                  </div>

                  <div className="pb-2 mt-4 overflow-hidden rounded-lg shadow-md">
                    <div className="max-w-full overflow-x-auto">
                      <div className="inline-block min-w-full ">
                        <div className="overflow-x-auto">

                          <table className="min-w-full border-0 divide-y ">
                            <thead className="bg-gray-200 rounded-t">
                              <tr className="text-sm font-semibold text-left text-gray-500 uppercase">
                                <th className="px-6 py-3 whitespace-nowrap">#</th>
                                <th className="px-6 py-3 whitespace-nowrap">Lead Name</th>
                                <th className="px-6 py-3 whitespace-nowrap">Ticket No.</th>
                                <th className="px-6 py-3 whitespace-nowrap">Requirement</th>
                                <th className="px-6 py-3 whitespace-nowrap">Reminder Date</th>
                                <th className="px-6 py-3 whitespace-nowrap">Remark</th>
                                <th className="px-6 py-3 whitespace-nowrap">Date ( Time )</th>
                                <th className="px-6 py-3 whitespace-nowrap">Enable/Disable</th>
                                <th className="px-6 py-3 text-center whitespace-nowrap">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reminderItems && reminderItems.length > 0 ?
                                reminderItems.map((element, index) => (
                                  <React.Fragment key={element.id}>
                                    <tr key={element.id} className="bg-white border-b border-black border-opacity-10 ">
                                      <td className="px-6 py-3 text-sm font-medium text-gray-600 whitespace-nowrap">
                                        {this.state.offset + index + 1}</td>
                                      <td className="px-6 py-3 text-sm text-gray-600 whitespace-nowrap">{element && element.leadId
                                        && element.leadId.name ? element.leadId.name : "-"}</td>
                                      <td className="px-6 py-3 text-sm text-gray-600 whitespace-nowrap">{element && element.slug ? element.slug : "-"}</td>
                                      <td className="px-6 py-3 text-sm text-gray-600" title={element.leadId.requirement}>
                                        {element && element.leadId && element.leadId.requirement.length > 20 ? element.leadId.requirement.substring(0, 20) + "...." : element.leadId.requirement}
                                      </td>
                                      <td className="px-6 py-3 text-sm text-gray-600 whitespace-nowrap">
                                        {moment(new Date(parseInt(element.reminderDate))).format("DD-MM-YYYY (HH:mm A)")}
                                      </td>
                                      <td className="px-6 py-3 text-sm text-gray-600" title={element && element.comment ? element.comment : ""}>
                                        {element && element.comment.length > 20 ? element.comment.substring(0, 20) + "..." : element.comment}
                                      </td>
                                      <td className="px-6 py-3 text-sm text-gray-600 whitespace-nowrap">
                                        {moment(new Date(parseInt(element.createdAt))).utcOffset("+05:30").format("DD-MM-YYYY (HH:mm A)")}
                                      </td>
                                      <td className="px-2 py-3 text-sm text-gray-600 whitespace-nowrap">
                                        <span className="flex justify-center pl-1">
                                          {element.isFollowup === false ?
                                            <div class="targetablepx-4 tooltip px-3 py-1 font-medium tracking-wider text-blue-100 bg-green-700 border rounded-md shadow-sm hover:shadow-lg hover:bg-green-400 cursor-pointer" onClick={() => this.disableReminder(element)}>
                                              <label>Active</label>
                                            </div>
                                            : <div class="targetablepx-4 tooltip px-3 py-1 font-medium tracking-wider text-blue-100 bg-red-500 border rounded-md shadow-sm hover:shadow-lg hover:bg-green-400 cursor-pointer" onClick={() => this.disableReminder(element)}>
                                              <label>Deactive</label>
                                            </div>}
                                        </span>
                                      </td>
                                      <td className="flex justify-center px-2 py-3 space-x-2 text-center text-gray-600 whitespace-nowrap">
                                        <div className='flex space-x-2'>
                                          <span className="relative">
                                            <div class="targetablepx-4 tooltip p-2 rounded-full font-medium hover:bg-blue-100 cursor-pointer" onClick={() => this.handleFollowUpOpenModal(element)}>
                                              <span className='top-0 left-0 p-6 mx-auto -mt-8 text-sm text-white bg-gray-500 rounded tooltip-text'>Add Follow Up</span>
                                              <GrAddCircle style={{ fontSize: "1.5rem" }} />
                                            </div>
                                          </span>
                                          <span className="relative ">
                                            <div class="targetablepx-4 tooltip p-2 rounded-full font-medium hover:bg-blue-100 cursor-pointer" onClick={() => this.handleShowFollowUpModal(element)}>
                                              <span className='top-0 left-0 p-6 mx-auto -mt-8 text-sm text-white bg-gray-500 rounded tooltip-text'>Show Follow List</span>
                                              <BiDetail style={{ fontSize: "1.5rem" }} />
                                            </div>
                                          </span>
                                          <span className="relative ">
                                            <div class="targetablepx-4 tooltip p-2 rounded-full font-medium hover:bg-blue-100 cursor-pointer" onClick={() => this.handleOpenCreateModalMoreDetails(element)}>
                                              <span className='top-0 left-0 p-6 mx-auto -mt-8 text-sm text-white bg-gray-500 rounded tooltip-text'>More Details</span>
                                              <BiDetail style={{ fontSize: "1.5rem" }} />
                                            </div>
                                          </span>
                                          {/* <span className="relative">
                                            <div class="targetablepx-4 tooltip p-2 rounded-full font-medium hover:bg-blue-100 cursor-pointer" onClick={() => this.handleOpenCreateModalUpdatePassword(element)}>
                                              <span className='top-0 left-0 p-6 mx-auto -mt-8 text-sm text-white bg-gray-500 rounded tooltip-text'>Edit</span>
                                              <MdOutlineEdit style={{ fontSize: "1.5rem" }} />
                                            </div>
                                          </span> */}
                                        </div>
                                      </td>

                                    </tr>
                                  </React.Fragment>))
                                : (<tr className="bg-white bg-opacity-5 " >
                                  <td className="col-span-3 px-6 py-3 text-sm font-medium text-gray-500 whitespace-nowrap">Not Found</td>
                                </tr>)
                              }
                            </tbody>

                          </table>
                        </div>
                      </div>
                    </div>
                    {isMobile ?
                      <nav className="relative z-0 flex justify-end mt-5 w-76">
                        {
                          reminderTotal && reminderTotal > 10 ?
                            <ReactPaginate
                              previousLabel={'Prev'}
                              nextLabel={'Next'}
                              breakLabel={'...'}
                              breakClassName={'break-me'}
                              pageCount={reminderTotal / this.state.size}
                              marginPagesDisplayed={1}
                              pageRangeDisplayed={1}
                              onPageChange={this.handlePageClick}
                              containerClassName={'pagination'}
                              pageClassName={'page-cls'}
                              activeClassName={'active'}
                            />
                            : null}
                      </nav> : <nav className="relative z-0 flex justify-end mt-5 w-76">
                        {reminderTotal && reminderTotal > 10 ?
                          <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={reminderTotal / this.state.size}
                            marginPagesDisplayed={3}
                            pageRangeDisplayed={3}
                            onPageChange={this.handlePageClick}
                            containerClassName={'pagination'}
                            pageClassName={'page-cls'}
                            activeClassName={'active'}
                          />
                          : null}
                      </nav>}
                  </div>
                </section>
              </div>
            </div>
          </main>
        </div>

        <DialogExample />

        <AddLeadModal
          handleCreditActivityHideModal={this.handleCreditActivityHideModal}
          getAllCategory={getAllCategory}
          getAllUser={getAllUser}
          options={getAllCategory}
          selectedValue={this.state.selectedValue}
          onSelect={this.onSelect}
          onRemove={this.onRemove}
          onUserSelect={this.onUserSelect}
          onUserRemove={this.onUserRemove}
          handleSelectedTag={this.handleSelectedTag}
          selectedTag={this.state.selectedTag}
          addLeadModal={this.state.addLeadModal}
          addQuoteModal={this.state.addQuoteModal}
          fieldsQuote={this.state.fieldsQuote}
          errorsQuote={this.state.errorsQuote}
          inputAddUserChange={this.inputAddUserChange}
          createLeadSubmit={this.createLeadSubmit}
          createQuoteSubmit={this.createQuoteSubmit}
          handleSelectType={this.handleSelectType}
          handleAddUserHideModal={this.handleAddUserHideModal}
        />

        <UpdateLeadModal
          getAllCategory={getAllCategory}
          getAllUser={getAllUser}
          updateSelectedUser={this.state.updateSelectedUser}
          updateSelectedCategory={this.state.updateSelectedCategory}
          onSelectUpdate={this.onSelectUpdate}
          onRemoveUpdate={this.onRemoveUpdate}
          onUserSelectUpdate={this.onUserSelectUpdate}
          onUserRemoveUpdate={this.onUserRemoveUpdate}
          UpdateQuoteCreateModal={this.state.UpdateQuoteCreateModal}
          fieldsUserUpdate={this.state.fieldsUserUpdate}
          errorsUpdateQuote={this.state.errorsUpdateQuote}
          inputChangeUpdateUser={this.inputChangeUpdateUser}
          updateLead={this.updateLead}
          handleAppSeetingHideModal={this.handleUpdatePasswordHideModal}
        />

        <AddFollowUpModal
          fieldsFollowUp={this.state.fieldsFollowUp}
          errorsFollowUp={this.state.errorsFollowUp}
          inputChangeFollowUp={this.inputChangeFollowUp}
          handleDateChange={this.handleDateChange}
          createFollowUp={this.createFollowUp}
          handleFollowUpHideModal={this.handleFollowUpHideModal}
          followUpModal={this.state.followUpModal}
          show={this.state.show}
          handleCalender={this.handleCalender}

        />

        <ShowFollowUpModal
          handleHideFollowUpModal={this.handleHideFollowUpModal}
          showFollowUpModal={this.state.showFollowUpModal}
          followUpItems={followUpItems}
          followUpTotal={followUpTotal}
          offset={this.state.offset}
        />
      </>

    );
  }
}
function mapStateToProps(state) {
  const { users } = state;
  return {
    users
  };
}
export default connect(mapStateToProps)(ActiveReminder);
